




























import Vue from 'vue'
import { ProductEditPattern } from '@/product/types'
import EditPatternOption from '@/product/components/printingOptions/EditPatternOption.vue'

interface ExtendedProductEditPattern extends ProductEditPattern {
  isDisabled: boolean
}

export default Vue.extend({
  components: { EditPatternOption },
  props: {
    editPatterns: {
      type: Array as () => ProductEditPattern[],
      required: true
    },
    filteredEditPatterns: {
      type: Array as () => ProductEditPattern[],
      required: true
    },
    selectedPattern: {
      type: Object as () => ProductEditPattern,
      default: undefined
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    showRequiredMessage: {
      type: Boolean,
      default: false
    },
    enableAllOptions: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayEditPatterns(): ExtendedProductEditPattern[] {
      if (this.enableAllOptions || this.isDisabled) {
        return this.editPatterns.map(item => ({
          ...item,
          isDisabled: this.enableAllOptions ? false : true
        }))
      } else {
        return this.editPatterns.map(item => ({
          ...item,
          isDisabled: !this.filteredEditPatterns.find(
            filteredItem => filteredItem.editPattern.displayName === item.editPattern.displayName
          )
        }))
      }
    }
  }
})
